// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AccountSource = { accountId?: string; amount?: any; [key: string]: any };

// AEX-3218: overlays the balances edited in the Update Balances modal onto `sources`, matched by accountId,
// so every other account (and field) keeps the data in `sources`. Returns null when none of the edited
// accounts is found in `sources`. Returns a new array; the inputs are not mutated.
export const applyEditedBalances = (
    sources: AccountSource[] = [],
    editedAccounts: AccountSource[] = []
): AccountSource[] | null => {
    const editedAmountById = new Map(
        editedAccounts.filter((account) => account?.accountId).map((account) => [account.accountId, account.amount])
    );
    let hasEditedBalance = false;
    const nextSources = sources.map((source) => {
        if (!source?.accountId || !editedAmountById.has(source.accountId)) return source;
        hasEditedBalance = true;
        return { ...source, amount: editedAmountById.get(source.accountId) };
    });
    return hasEditedBalance ? nextSources : null;
};
